// extracted by mini-css-extract-plugin
export default {"ScrollDown":"ScrollDown_ScrollDown__ybCvt"};